
import {
    deleteQueueErrorPayLoad,
    deleteQueueSuccessPayload,

    GetCallQueueErrorPayLoad,
    GetCallQueueRequestPayload,
    GetCallQueueSuccessPayload,
    InsertCallQueueErrorPayLoad,
    InsertCallQueueRequestPayload,
    InsertCallQueueSuccessPayload,
    updateErrorPayLoad,
    updateRequestPayload,
    updateSuccessPayload,
    uploadDefaultMusicErrorPayLoad,
    uploadDefaultMusicRequestPayload,
    uploadDefaultMusicSuccessPayload,

    getActiveQueueSuccessPayload,
    getActiveQueueErrorPayLoad
} from "../interfaces/queue";

import {
    deleteQueueError,
    deleteQueueRequest,
    deleteQueueSuccess,
       GetCallQueueError,
    GetCallQueueRequest,
    GetCallQueueSuccess,
    InsertCallQueueError,
    InsertCallQueueRequest,
    InsertCallQueueSuccess,
    resetDeleteCustomerMemberRequest,
    resetInsertActionRequest,
    resetUpdateActionRequest,
    resetUpSertActionRequest,
    updateError,
    updateRequest,
    updateSuccess,
    uploadDefaultMusicError,
    uploadDefaultMusicRequest,
    uploadDefaultMusicSuccess,
     getActiveQueueRequest,
    getActiveQueueSuccess,
    getActiveQueueError,
    resetActiveQueueActionRequest,
    resetDeleteActionRequest
} from "../types/Queues/actionsType";

import { Types } from "../types";

//InsertCallQueue********************************************************************************************************************* */
export const insertCallQueueRequestAction = (payload: InsertCallQueueRequestPayload): InsertCallQueueRequest => ({
    type: Types.INSERT_CALL_QUEUE_REQUEST,
    payload
})

export const insertCallQueueSuccessAction = (payload: InsertCallQueueSuccessPayload): InsertCallQueueSuccess => ({
    type: Types.INSERT_CALL_QUEUE_SUCCESS,
    payload
})

export const insertCallQueueErrorAction = (payload: InsertCallQueueErrorPayLoad): InsertCallQueueError => ({
    type: Types.INSERT_CALL_QUEUE_ERROR,
    payload
})

//get*************************************************************************************************************************************** */
export const getCallQueueRequestAction = (payload: GetCallQueueRequestPayload): GetCallQueueRequest => ({
    type: Types.GET_QUEUE_REQUEST,
    payload
})

export const getCallQueueSuccessAction = (payload: GetCallQueueSuccessPayload): GetCallQueueSuccess => ({
    type: Types.GET_QUEUE_SUCCESS,
    payload
})

export const getCallQueueErrorAction = (payload: GetCallQueueErrorPayLoad): GetCallQueueError => ({
    type: Types.GET_QUEUE_ERROR,
    payload
})
//uploadDefaultMusic**************************************************************************************************************************************** */
export const uploadDefaultMusicRequestAction = (payload: uploadDefaultMusicRequestPayload): uploadDefaultMusicRequest => ({
    type: Types.UPLOAD_DEFAULT_MUSIC_REQUEST,
    payload
})

export const uploadDefaultMusicSuccessAction = (payload: uploadDefaultMusicSuccessPayload): uploadDefaultMusicSuccess => ({
    type: Types.UPLOAD_DEFAULT_MUSIC_SUCCESS,
    payload
})

export const uploadDefaultMusicErrorAction = (payload: uploadDefaultMusicErrorPayLoad): uploadDefaultMusicError => ({
    type: Types.UPLOAD_DEFAULT_MUSIC_ERROR,
    payload
})
//Update***************************************************************************************************************************************
export const updateRequestAction = (payload: updateRequestPayload): updateRequest => ({
    type: Types.UPDATE_QUEUE_REQUEST,
    payload
})

export const updateSuccessAction = (payload: updateSuccessPayload): updateSuccess => ({
    type: Types.UPDATE_QUEUE_SUCCESS,
    payload
})

export const updateErrorAction = (payload: updateErrorPayLoad): updateError => ({
    type: Types.UPDATE_QUEUE_ERROR,
    payload
})
//delete*****************************************************************************************************************************************
export const deleteRequestAction = (payload: string): deleteQueueRequest => ({
    type: Types.DELETE_QUEUE_REQUEST,
    payload
})

export const deleteSuccessAction = (payload: deleteQueueSuccessPayload): deleteQueueSuccess => ({
    type: Types.DELETE_QUEUE_SUCCESS,
    payload
})

export const deleteErrorAction = (payload: deleteQueueErrorPayLoad): deleteQueueError => ({
    type: Types.DELETE_QUEUE_ERROR,
    payload
})

//getActiveQueue
export const getActiveQueueRequestAction = (payload: string): getActiveQueueRequest => ({
    type: Types.GET_ACTIVE_QUEUE_REQUEST,
    payload
})

export const getActiveQueueSuccessAction = (payload: getActiveQueueSuccessPayload): getActiveQueueSuccess => ({
    type: Types.GET_ACTIVE_QUEUE_SUCCESS,
    payload
})

export const getActiveQueueErrorAction = (payload: getActiveQueueErrorPayLoad): getActiveQueueError => ({
    type: Types.GET_ACTIVE_QUEUE_ERROR,
    payload
})

//resetInsetQueu************************************************************************************************************************************
export const resetInserQueueAction = (): resetInsertActionRequest => ({
    type: Types.RESET_INSERT_QUEUE,
})

export const resetUpdateAction = (): resetUpdateActionRequest => ({
    type: Types.RESET_UPDATE_QUEUE,
})

export const resetUpsertAction = (): resetUpSertActionRequest => ({
    type: Types.RESET_UPSERT_QUEUE,
})

export const resetDeleteCustomerMemberAction = (): resetDeleteCustomerMemberRequest => ({
    type: Types.RESET_DELETE_CUSTOMER_MEMBER_QUEUE,
})




export const resetActiveQueueAction = (): resetActiveQueueActionRequest => ({
    type: Types.RESET_ACTIVE_QUEUE,
})


export const resetDeleteAction = (): resetDeleteActionRequest => ({
    type: Types.RESET_DELETE_QUEUE,
})


